import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#444545",
  "stroke-linecap": "round",
  "stroke-width": "3",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M237.533 1.51H1.538v235.996h235.995z\"></path><g stroke-linecap=\"butt\"><path d=\"m1.466 1.494 117.998 117.998L1.466 237.489M31.002 1.494l117.997 117.998L31.002 237.489M60.534 1.494l117.998 117.998L60.534 237.489M89.93 1.494l117.998 117.998L89.93 237.489M119.466 1.494l117.997 117.998-117.997 117.997\"></path><path d=\"m149 1.494-14.768 14.767m44.301-14.767L149 31.028m58.93-29.534-44.163 44.3m73.695-44.3-58.929 59.068m-29.533 176.927-14.767-14.767m73.696 14.767-44.162-44.163m14.767 44.163L149 208.093m88.462-177.065-44.163 44.3m44.163 14.768-14.766 14.629m14.766-44.163-29.533 29.534m29.533 58.93-14.766-14.767m14.766 73.834-44.163-44.3m44.163 73.696-58.929-58.93m58.93 0-29.534-29.533M1.466 31.028l88.464 88.464-88.464 88.601\"></path><path d=\"m1.466 60.562 59.068 58.93-59.068 59.067\"></path><path d=\"M1.466 90.096 31 119.492 1.466 149.025\"></path></g>", 2)
  ])))
}
export default { render: render }